import { render, staticRenderFns } from "./ImageDetailsStepThree.vue?vue&type=template&id=96f419b6&scoped=true&"
import script from "./ImageDetailsStepThree.vue?vue&type=script&lang=js&"
export * from "./ImageDetailsStepThree.vue?vue&type=script&lang=js&"
import style0 from "./ImageDetailsStepThree.vue?vue&type=style&index=0&id=96f419b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f419b6",
  null
  
)

export default component.exports